import React, { useEffect, useState } from 'react';
import { Text, Button, Box, Input } from '@chakra-ui/react';
import { ChevronLeftIcon, ChevronRightIcon } from '@chakra-ui/icons';
import {
  Pagination,
  usePagination,
  PaginationNext,
  PaginationPage,
  PaginationPrevious,
  PaginationContainer,
  PaginationPageGroup,
  PaginationSeparator,
} from '@ajna/pagination';
import { useDispatch, useTrackedState } from '../../config/store';

function PaginationNavbar() {
  const state = useTrackedState();
  const [inputFieldPage, setInputFieldPage] = useState('');

  const { currentPage, setCurrentPage, pagesCount, pages } = usePagination({
    pagesCount: state?.pagination?.totalPages,
    initialState: { currentPage: state?.pagination?.page, pageSize: 10 },
    limits: {
      outer: 1,
      inner: 3,
    },
  });

  const dispatch = useDispatch();

  useEffect(() => {
    if (state?.pagination?.page) {
      setCurrentPage(state?.pagination?.page);
    }
  }, [state?.pagination?.page]);

  // handlers
  const handlePageChange = nextPage => {
    dispatch({
      type: 'GET_INTERVIEWS_PAGINATION_PARAMS',
      token: state?.user?.token,
      page: nextPage,
      interviewStatusFilter: state.interviewStatusFilter,
      interviewCompleted: state.interviewCompleted,
      interviewReportPending: state.interviewReportPending,
      interviewScheduled: state.interviewScheduled,
      missingVideo: state.missingVideo,
    });
    setCurrentPage(nextPage);
  };

  const handleInputFieldPageChange = event => {
    setInputFieldPage(event.target.value);
  };

  const goSpecificPageChange = () => {
    if (inputFieldPage > 0 && inputFieldPage <= state?.pagination?.totalPages) {
      handlePageChange(inputFieldPage);
    } else if (inputFieldPage > state?.pagination?.totalPages) {
      handlePageChange(state?.pagination?.totalPages);
    }
    setInputFieldPage('');
  };

  return (
    <Pagination pagesCount={pagesCount} currentPage={currentPage} onPageChange={handlePageChange}>
      <PaginationContainer
        marginRight='auto'
        marginLeft='auto'
        marginTop='12px'
        align='center'
        alignItems='center'
        justify='space-around'
        w='720'
        minW='720'
        maxWidth='800px'>
        <PaginationContainer
          marginLeft='160px'
          align='center'
          alignItems='center'
          justify='space-around'
          w='320px'
          maxWidth='800px'>
          <PaginationPrevious marginX='4px' w='24px' h='32px' backgroundColor='transparent' color='gray.500'>
            <ChevronLeftIcon w='32px' h='32px' />
          </PaginationPrevious>
          <PaginationPageGroup height='24px' separator={<PaginationSeparator height='24px' color='gray.500' />}>
            {pages.map(page => (
              <PaginationPage
                w='24px'
                h='24px'
                mx='4px'
                fontSize='14px'
                fontWeight='400'
                lineHeight='unset'
                letterSpacing='unset'
                bg='transparent'
                color='gray.500'
                _hover={{
                  color: 'white',
                  bg: 'gray.900',
                }}
                _current={{
                  w: '24px',
                  h: '24px',
                  color: 'white',
                  bg: 'gray.900',
                  fontWeight: '500',
                }}
                key={`pagination_page_${page}`}
                page={page}
              />
            ))}
          </PaginationPageGroup>
          <PaginationNext marginX='4px' w='24px' h='32px' backgroundColor='transparent' color='gray.500'>
            <ChevronRightIcon w='32px' h='32px' />
          </PaginationNext>
        </PaginationContainer>

        <Box marginTop='5px'>
          <Text as='span' fontSize='14px' color='gray.900'>
            Go to page:
          </Text>
          <Input
            disabled={state?.pagination?.totalPages === 1}
            size='sm'
            w='60px'
            borderRadius='48px'
            borderColor='gray.300'
            color='gray.900'
            marginX='8px'
            textAlign='center'
            type='number'
            value={inputFieldPage}
            onChange={handleInputFieldPageChange}
          />
          <Button
            disabled={state?.pagination?.totalPages === 1}
            size='sm'
            lineHeight='unset'
            w='64px'
            backgroundColor='gray.100'
            color='gray.600'
            onClick={goSpecificPageChange}>
            GO
          </Button>
        </Box>
      </PaginationContainer>
    </Pagination>
  );
}

export default PaginationNavbar;
